'use client';

import { useAction } from 'convex/react';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useRouter } from 'nextjs-toploader/app';
import { api } from '@/convex/_generated/api';
import { deliverRealtimeVoiceNavigation } from '@/lib/realtime-voice-navigation';

export function useRealtimeVoiceNavigationActions() {
  const findNavigationTargets = useAction(
    api.voice.realtime_navigation.discover
  );
  const navigateUi = useAction(api.voice.realtime_navigation.navigate);
  const router = useRouter();
  const routerRef = useRef(router);
  useEffect(() => {
    routerRef.current = router;
  }, [router]);
  // A pathname change must not replace the actions captured by the live call.
  const deliverNavigation = useCallback(
    (navigation: unknown) =>
      deliverRealtimeVoiceNavigation({
        navigation,
        origin: window.location.origin,
        push: (href) => routerRef.current.push(href),
        openExternal: (href) => {
          const destination = window.open('about:blank', '_blank');
          if (!destination) return false;
          destination.opener = null;
          destination.location.href = href;
          return true;
        },
      }),
    []
  );
  return useMemo(
    () => ({ findNavigationTargets, navigateUi, deliverNavigation }),
    [findNavigationTargets, navigateUi, deliverNavigation]
  );
}
